(function() {
  // First, wait for BuddhaMegaMenuMain to be available 
  function checkForBuddhaMenu() {
    if (typeof BuddhaMegaMenuMain !== 'undefined') {
      // Store original initBuddhaMegaMenu
      const originalInitBuddhaMegaMenu = window.initBuddhaMegaMenu;

      // Override initBuddhaMegaMenu to add our enhancement
      window.initBuddhaMegaMenu = function() {
        if (originalInitBuddhaMegaMenu) {
          originalInitBuddhaMegaMenu();
        }
        
        // Wait a bit for menu to be fully initialized
        setTimeout(initColorBoxEnhancer, 1000);
      };

      // Start the initialization
      BuddhaMegaMenuMain();
    } else {
      setTimeout(checkForBuddhaMenu, 100);
    }
  }

  function initColorBoxEnhancer() {
    const styles = `
      .mm-title {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 8px !important;
        position: relative !important;
        width: 100% !important;
      }

      .mm-list-name .mm-title {
        color: #da98a3 !important
      }
      
      .mm-title span:first-child {
        flex: 1 !important;
      }
      
      .color-box {
        display: inline-block !important;
        width: 32px !important;
        height: 16px !important;
        border-radius: 2px !important;
        transition: transform 0.2s ease !important;
        margin-left: 34px !important;
        min-width: 32px !important;
        transform: translateY(3px) !important;
      }

      .red-color-box { margin-left: 38px !important; }
      .black-color-box { margin-left: 28px !important; }
      .white-color-box { margin-left: 28px !important; }
      .green-color-box { margin-left: 26px !important; }
      .blue-color-box { margin-left: 36px !important; }
      .purple-color-box { margin-left: 34px !important; }
      .orange-color-box { margin-left: 34px !important; }
      .gold-color-box { margin-left: 35px !important; }
      .silver-color-box { margin-left: 34px !important; }
      .pink-color-box { margin-left: 35px !important; }
      .maroon-color-box { margin-left: 16px !important; }
      .yellow-color-box { margin-left: 24px !important; }
      .beige-color-box { margin-left: 30px !important; }
      
      /* Menu item styling */
      .mm-submenu.link-list li {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        padding-right: 10px !important;
      }

      /* Mobile drawer specific styles */
      .menu-drawer .mm-title {
        padding-right: 5px !important;
      }
      
      .menu-drawer .color-box {
        margin-left: 5px !important;
      }
      
      /* Vertical mega menu (mobile) specific styles */
      .vertical-mega-menu .mm-title {
        padding-right: 5px !important;
      }
    `;

    const styleSheet = document.createElement("style");
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);

    const colorMap = {
      'red': '#ff0000',
      'black': '#000000',
      'white': '#ffffff',
      'green': '#008000',
      'blue': '#0000ff',
      'purple': '#800080',
      'orange': '#ffa500',
      'gold': '#ffd700',
      'silver': '#c0c0c0',
      'pink': '#ffc0cb',
      'yellow': '#ffff00',
      'maroon': '#800000',
      'beige': '#F5F5DC'
    };

    // Keep track of processed sections to avoid repeating work
    const processedSections = new WeakSet();
    
    // Store last execution timestamp to throttle calls
    let lastExecution = 0;
    const throttleTime = 300; // ms
    
    // Main enhancement function
    function enhanceColorMenus() {
      // Throttle executions
      const now = Date.now();
      if (now - lastExecution < throttleTime) {
        return;
      }
      lastExecution = now;
      
      // Target both desktop and mobile menus
      const colorSections = document.querySelectorAll('.mm-list-name');
      
      let enhancementsMade = 0;
      
      colorSections.forEach((section) => {
        // Skip if we've already processed this section
        if (processedSections.has(section)) {
          return;
        }
        
        if (section.textContent.includes('SHOP BY COLOR')) {
          const colorList = section.closest('.mega-menu-item-container')
            ?.querySelector('.mm-submenu.link-list');
          
          if (colorList) {
            const colorItems = colorList.querySelectorAll('li');
            
            colorItems.forEach((item) => {
              const titleSpan = item.querySelector('.mm-title');
              if (!titleSpan) return;
              
              const colorName = titleSpan.textContent.trim().toLowerCase();
              
              // Check if this item already has the final state we want
              const existingBox = titleSpan.querySelector('.color-box');
              const needsBox = !existingBox && colorMap[colorName];
              
              if (needsBox) {
                const colorBox = document.createElement('span');
                const colorClass = colorName.toLowerCase().replace(/\s+/g, '-') + '-color-box';
                colorBox.className = `color-box ${colorClass}`;
                colorBox.style.cssText = `
                  background-color: ${colorMap[colorName]} !important;
                  ${colorName === 'white' ? 'border: 1px solid #e0e0e0 !important;' : ''}
                `;
                
                // Add a data attribute to mark this as our managed element
                colorBox.setAttribute('data-color-enhancer', 'true');
                
                titleSpan.appendChild(colorBox);
                enhancementsMade++;
              }
            });
            
            // Mark this section as processed
            processedSections.add(section);
          }
        }
      });
      
      return enhancementsMade;
    }

    // Handle menu interactions for both desktop and mobile - using a debounced approach
    let clickTimer;
    document.addEventListener('click', function(e) {
      if (e.target.closest('.buddha-menu-item') || e.target.closest('.menu-drawer__menu-item')) {
        clearTimeout(clickTimer);
        clickTimer = setTimeout(() => {
          enhanceColorMenus();
        }, 200);
      }
    });

    // Handle hover for desktop menu - again with debouncing
    let hoverTimer;
    document.addEventListener('mouseover', function(e) {
      if (e.target.closest('.horizontal-mega-menu')) {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          enhanceColorMenus();
        }, 200);
      }
    });

    // Special handler for mobile drawer toggle
    const drawerToggles = document.querySelectorAll('.toggle-menu-btn');
    drawerToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        setTimeout(enhanceColorMenus, 300);
      });
    });

    // Initial enhancement with longer timeout
    setTimeout(() => {
      enhanceColorMenus();
    }, 1000);

    // Handle DOM ready and window load events - menus might be loaded asynchronously
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(enhanceColorMenus, 500);
    });
    
    window.addEventListener('load', () => {
      setTimeout(enhanceColorMenus, 1000);
    });

    // Create a simpler, smarter MutationObserver with built-in throttling
    let pendingMutations = false;
    
    const observer = new MutationObserver((mutations) => {
      // Skip our own mutations
      const isRelevant = mutations.some(mutation => {
        // If this is a childList mutation, check if it's just our own color boxes
        if (mutation.type === 'childList') {
          // We're only concerned with element nodes
          const relevantAddedNodes = Array.from(mutation.addedNodes).filter(node => 
            node.nodeType === 1 && !node.classList?.contains('color-box')
          );
          
          if (relevantAddedNodes.length > 0) {
            return true;
          }
        }
        
        // If this is an attributes mutation on something other than our color boxes
        if (mutation.type === 'attributes') {
          if (!mutation.target.classList?.contains('color-box') && 
              !mutation.target.getAttribute('data-color-enhancer')) {
            return true;
          }
        }
        
        return false;
      });
      
      if (!isRelevant) {
        return;
      }
      
      if (!pendingMutations) {
        pendingMutations = true;
        
        setTimeout(() => {
          enhanceColorMenus();
          pendingMutations = false;
        }, 500);
      }
    });

    // Observe the entire document body, but with a more specific configuration
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
    });
    
    // Return the public API
    return {
      enhance: enhanceColorMenus,
      clearCache: () => {
        processedSections = new WeakSet();
      }
    };
  }

  // Start checking for Buddha Menu
  checkForBuddhaMenu();
})();